import { useField } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

export const DogsName = (props: any) => {
  const [field, meta, helpers] = useField('dogsName');
  const { setValue, setTouched } = helpers;

  const setFieldValue = (value: string) => {
    setValue(value);
    setTouched(true);
  };
  const value = meta?.value || '';
  return (
    <div className="margin-top-botton-17">
      <Form.Group controlId="formDogsName" className="align-col-cen">
        <Form.Label className='form-label'>What is your dog's name?</Form.Label>
        <Form.Control
          className="placeholder"
          type="text"
          name="dogsName"
          placeholder="Type your dog’s name here."
          value={props?.values.dogsName}
          isInvalid={!!props.errors.dogsName && props.touched.dogsName}
          onChange={props.handleChange}
          maxLength={20}
          // onChange={e => {
          //   setFieldValue(e.target.value);
          // }}
        />
        <Form.Control.Feedback type="invalid">
          {props.errors?.dogsName}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
};

export default DogsName;
